import { useEffect, useRef } from "react";

import { useWizards } from "@/wizards/framework/WizardProvider";
import { ADD_ENVIRONMENT_WIZARD_TYPE } from "./constants";
import { AddEnvironmentData } from "./types";

/**
 * Completes the session when its panel closes after the environment was
 * created. Sessions are stored per environment, and clicking the sidebar
 * picker closes the panel before the switch, so without this the session
 * would stay in progress in the old environment's dock. Runs as the wizard's
 * step context hook, which the framework calls only while the panel is open.
 */
export function useCompleteOnClose(data: AddEnvironmentData): undefined {
  const { findInProgressSession, completeWizard } = useWizards();
  const sessionId = findInProgressSession(ADD_ENVIRONMENT_WIZARD_TYPE)?.id;
  const latest = useRef({ created: data.created, sessionId, completeWizard });
  latest.current = { created: data.created, sessionId, completeWizard };

  useEffect(
    () => () => {
      const {
        created,
        sessionId: id,
        completeWizard: complete,
      } = latest.current;
      if (created && id) {
        complete(id, "switch");
      }
    },
    [],
  );
  return undefined;
}
